import {
	ArrowClockwise28Regular,
	Checkmark12Regular,
	Dismiss20Filled,
} from '@fluentui/react-icons'
import { styled, css } from '@styles/theme'

export const ListHistorytyles = {
	Container: styled('div', {
		background: '$neutral10',
		border: '1px solid $neutral40',
		borderRadius: '12px',
		paddingBottom: '21px',

		variants: {
			isProfile: {
				true: {
					width: '100%',
					background: 'rgb(223, 222, 222,0.1)',
					border: '0px',
					paddingBottom: '0px',
				},
			},
		},
	}),

	header: css({
		display: 'flex',
		flexDirection: 'column-reverse',
		padding: '17px 16px 0px',

		'@sm': {
			flexDirection: 'row',
			justifyContent: 'space-between',
			padding: '17px 32px 0px',
		},
	}),

	headerContainerDesc: css({
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		maxWidth: '317px',
		width: '100%',
		marginBottom: '16px',

		'@sm': {
			gridTemplateColumns: '1fr 1fr 1fr',
		},
	}),

	Line: styled('hr', {
		height: '1px',
		background: '$neutral50',
		border: '0px',
		marginBottom: '21px',
		margin: '0px 16px 21px 16px',

		'@sm': {
			margin: '0px 32px 21px 32px',
		},
	}),

	listContainer: css({
		listStyleType: 'none',

		p: {
			fontSize: '$md',
			'@sm': {
				fontSize: '$lg',
			},
		},
	}),

	RowList: styled('li', {
		display: 'flex',
		minHeight: '82px',
		gap: '19px',
		padding: '0px 16px 0px ',

		'@sm': {
			padding: '0px 32px 0px',
		},

		variants: {
			status: {
				clear_history: {
					'&:hover': {
						transition: 'all 0.6s ease',
						background: 'rgb(199, 66, 66, 0.12)',
					},
				},
				mock_finished: {
					'&:hover': {
						transition: 'all 0.6s ease',
						background: 'rgb(33, 150, 83, 0.12)',
					},
				},
				update: {
					'&:hover': {
						transition: 'all 0.6s ease',
						background: 'rgb(134, 137, 139, 0.12)',
					},
				},
			},

			isProfile: {
				true: {
					minHeight: '65px',
				},
			},
		},
	}),

	timeContainer: css({
		width: '130px',
		display: 'flex',
		flexDirection: 'column',

		'@sm': {
			width: '100%',
			maxWidth: 'max-content',
			flexDirection: 'row',
			justifyContent: 'space-between',
			gap: '32px',
		},
	}),

	DismissIcon: styled(Dismiss20Filled, {
		background: '$red',
		width: '24px',
		height: '24px',
		borderRadius: '50%',
		padding: '4px',
		color: '$neutral10',

		'@sm': {
			width: '28px',
			height: '28px',
		},
	}),

	ClockwiseIcon: styled(ArrowClockwise28Regular, {
		background: '$neutral90',
		width: '24px',
		height: '24px',
		borderRadius: '50%',
		padding: '4px',
		color: '$neutral10',

		'@sm': {
			width: '28px',
			height: '28px',
		},
	}),

	CheckmarkIcon: styled(Checkmark12Regular, {
		background: '$green',
		width: '24px',
		height: '24px',
		borderRadius: '50%',
		padding: '4px',
		color: '$neutral10',

		'@sm': {
			width: '28px',
			height: '28px',
		},
	}),

	VerticalLine: styled('div', {
		width: '2px',
		height: '43px',
		borderRadius: '4px',

		variants: {
			status: {
				clear_history: {
					background: '$red',
				},
				mock_finished: {
					background: '$green',
				},
				update: {
					background: '$neutral90',
				},
			},
			isProfile: {
				true: {
					'@sm': {
						height: '21px',
					},
				},
			},
		},
	}),

	iconContainer: css({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: '8px',
	}),
}
